import axios from 'axios';
import { getToken } from '@iso/lib/helpers/utility';
import { put } from 'redux-saga/effects';
import actions from '../../redux/auth/actions';
import * as cookie from 'js-cookie';
// const history = createBrowserHistory();
// const fakeApiCall = false; // auth0 or express JWT
const timeout = 30000;
const apiUrl = process.env.REACT_APP_API_URL;
// const systemId = process.env.REACT_APP_SYSTEM_ID;

let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store',
};

export function* get(uri, data, page, sort, token) {
    // this.checkToken();
    const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;
    // if (token) {
    headers = {
        ...headers,
        authorization: `Bearer ${sessionToken}`,
    };
    // }
    if (page) {
        headers = {
            ...headers,
            Range: `${page.page || 1}-${page.limit || 10}`,
        };
    }
    if (!sort) {
        sort = {
            sort: 'asc',
            sortBy: 'createdAt',
        };
    }
    const params = data ? toParams(data) : '';
    const sortField = `&sort=${sort.sort === 'asc' ? '' : '-'}${sort.sortBy}`;
    // console.log('HEADERS', headers);
    // console.log('URI', `${apiUrl}${uri}?${params}${sortField}`);
    return yield fetch(`${apiUrl}${uri}?${params}${sortField}`, {
        headers: headers,
        method: 'GET',
    });
}

export function* post(uri, data) {
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'POST',
        data,
    });
}

export function* postWithToken(uri, data, page, token) {
    const cookieData = cookie.get('token');
    const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : cookieData ? cookieData : null;
    console.log('COOKIE', cookieData);
    if (page) {
        headers = {
            ...headers,
            authorization: `Bearer ${sessionToken}`,
            Range: `${page.page || 1}-${page.limit || 50}`,
        };
    } else {
        headers = {
            ...headers,
            authorization: `Bearer ${sessionToken}`,
        };
    }
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'POST',
        data,
    });
}

export function* postBlob(uri, data) {
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'POST',
        data,
        responseType: 'blob',
    });
}
export function* PUT(uri, data) {
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'PUT',
        data,
    });
}

export function* DELETE(uri, data) {
    return yield fetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'DELETE',
        data,
    });
}

function toParams(data) {
    const url = Object.keys(data).map((k) => {
        return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
    }).join('&');
    return url;
}

function* forbidden() {
    yield localStorage.setItem('forbidToken', 1);
    yield put({
        type: actions.CHECK_AUTHORIZATION,
    });
}

export function* fetch(url, options) {
    // try {
    const result = yield axios.request({
        ...options,
        url,
        baseURL: apiUrl,
        timeout: timeout,
        headers: headers
    }).then((res) => {
        return res;
    }).catch((error) => {
        return error
    })
    // console.log('FETCH_SUCCESSA', result.status);
    // console.log('FETCH_SUCCESSB', result.response);
    if (result.status) {
        return result;
    } else {
        if (result.response.status === 401 || result.response.status === 403) {
            yield forbidden();
        } else {
            // console.log('FETCH_SUCCESSC', result);
            if (result.response) {
                // console.log('RESULT_RESPONSE_DATA', result.response);
                return result.response;
            }
        }
    }
}

export function* fetchWithForbidden(url, options) {
    const result = yield axios.request({
        ...options,
        url,
        baseURL: apiUrl,
        timeout: timeout,
        onDownloadProgress: progress => {
        }
    }).then((res) => {
        return res;
    }).catch((error) => {
        return error
    })

    if (result.status) {
        return result;
    } else {
        if (result.response.status === 401) {
            yield forbidden();
        } else {
            if (result.response) {
                return result.response;
            }
        }
    }
}
    // return finalResult;
    // } catch (err) {
    //     // console.log('FETCH_FAILED1', err);
    //     // console.log('FETCH_FAILED2', err.message);
    //     if (err.message.match(/401|403/ig).length > 0) {
    //         yield localStorage.setItem('forbidToken', 1);
    //         yield put({
    //             type: actions.CHECK_AUTHORIZATION,
    //         });
    //     }

    //     if (err.response) {
    //         console.log(err.response.data);
    //         return err.response.data;
    //     }